import { render, staticRenderFns } from "./monedasAdd.vue?vue&type=template&id=5e7c1616&"
import script from "./monedasAdd.vue?vue&type=script&lang=js&"
export * from "./monedasAdd.vue?vue&type=script&lang=js&"
import style0 from "./monedasAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports